import { render, staticRenderFns } from "./LocationLegal.vue?vue&type=template&id=1313eedf"
import script from "./LocationLegal.vue?vue&type=script&lang=js"
export * from "./LocationLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports